module.exports = __webpack_public_path__ + "img/start5.6b24eea3.svg";